var map = {
	"./demos/basic/index.ts": 85229,
	"./demos/citations/index.ts": 60062,
	"./demos/codeBlockRenderers/index.ts": 44489,
	"./demos/formula/index.ts": 45130,
	"./demos/html/index.ts": 68773,
	"./demos/mermaid/index.ts": 99945,
	"./demos/plugins/index.ts": 32028,
	"./demos/streamingRich/index.ts": 53960,
	"./demos/tagRenderers/index.ts": 87818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70423;